/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Geography_Order_CodeInputs */

const vi_report_geography_order_code = /** @type {(inputs: Report_Geography_Order_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã đơn`)
};

/**

* @param {Report_Geography_Order_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_geography_order_code = /** @type {((inputs?: Report_Geography_Order_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Geography_Order_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_geography_order_code(inputs)
});